import { render, staticRenderFns } from "./AdMaterialList.vue?vue&type=template&id=54e5dec8&scoped=true"
import script from "./AdMaterialList.vue?vue&type=script&lang=js"
export * from "./AdMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5dec8",
  null
  
)

export default component.exports